import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState, Text } from '@tiendanube/components';

import emptyProducts from './empty-products.png';
import { goTo } from '../../../../libs/nexo/helpers';
import nexo from '../../../../nexoClient';

function ProductListEmpty(): JSX.Element {
  const { t } = useTranslation();

  const onClickPrimary = () => goTo(nexo, '/products/new');

  return (
    <EmptyState
      image={emptyProducts}
      title={t('productEmptyResults.title')}
      primaryActionLabel={t('productEmptyResults.action')}
      onClickPrimary={onClickPrimary}
    >
      <Text>{`${t('productEmptyResults.body')}`}</Text>
    </EmptyState>
  );
}

export default ProductListEmpty;
